import React, {useState} from "react";
import * as palette from "../Variables";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styled from "styled-components";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Form from '../components/ContactForm.js';

const StyledContactSection= styled.section`
    padding: 22px 16px 44px 16px;

    @media (min-width: 768px) {
        padding: 36px 24px 72px 24px;

        .left {
            padding-right: 24px;
        }

        .right {
            padding-left: 24px;
        }

        .h2 {
            font-size: 26px;
            margin-bottom: 24px;
        }
    }

    @media (min-width: 830px) {
        .h2 {
            font-size: 32px;
        }
    }


    .bold {
        font-weight: 700;
        margin-bottom: 0;
    }

    ul {
        margin-bottom: 20px;
    }

    .row {
        align-items: center;
    }

    span {
        background: ${palette.gradientMain};
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin: 0;
    }
`;

const Contact = () => {

    AOS.init();
    return (
        <main>
            <StyledContactSection className={"last"}>
                <Container>
                    <Row className={"row"}>
                        <Col xs={12} md={5} className={"left"}>
                            <h1 className={"h2"}>Let's&nbsp;<span>get in touch</span></h1>
                            <p>I work with businesses and organizations to create intuitive, accessible digital experiences.</p>
                            <p className={"bold"}>I can help with:</p>
                            <ul>
                                <li>Website redesigns</li>
                                <li>UX audits</li>
                                <li>Accessibility improvements</li>
                                <li>Mobile app design</li>
                                <li>UI design</li>
                                <li>Ongoing design support</li>
                            </ul>
                            <p>Have a project in mind? Let’s talk!</p>
                        </Col>
                        <Col xs={12} md={1}></Col>
                        <Col xs={12} md={6}>
                            <Form/>
                        </Col>
                    </Row>
                </Container>
            </StyledContactSection>
        </main>
    )
}

export default Contact;